/**
 * @description 小节分享
 */
import { lang } from '@umu/ukit-lang';
import React, { ReactElement, JSXElementConstructor } from 'react';
import { Iconfont, Popover, Tooltip } from '@umu/umu-design';
import { childPostControl } from '@umu/umu-iframe/src/session/postMessage/childPostControl';
import { SessionMessageAction, SessionTriggerClickTypes } from '@umu/umu-iframe/src/session/messageActions';
import { ClipBoardButton } from './clipBoardButton';
import classNames from 'classnames';
import { tryIframeRegisterPostLoginAlwaysResolve } from '../../../../services/responsiveDisplay/course';
import './index.scss';

export interface IOperationOptionsItemProps {
    key: string;
    label: string | ReactElement<any, string | JSXElementConstructor<any>>;
    icon: JSX.Element;
    onClick?: () => void;
}
export const OperationOptionsItem = (props: IOperationOptionsItemProps) => {
    const { key, label = '', onClick, icon } = props;
    return (
        <div
            className="biz-sib-share-operation"
            key={key}
            onClick={() => {
                onClick && onClick();
            }}
        >
            <div className="biz-sib-share-item">
                {icon}
                <span className='label'>{label}</span>
            </div>
        </div>
    );
};
interface IOperationOptionsProps {
    sessionId: string;
    sharePcUrl: string;
}
const OperationOptions = (props: IOperationOptionsProps) => {
    const postMsgPayloadFactory = (clickType: SessionTriggerClickTypes) => {
        return {
            action: SessionMessageAction.triggerClick,
            data: {
                clickType: clickType,
                sessionId: props.sessionId,
            },
        };
    }
    const operationsList = [
        {
            icon: <Iconfont className="icon" type="ShareCard" />,
            label: lang('分享邀请卡'), // 不需要登录
            onClick: () => {
                // tryIframeRegisterPostLoginAlwaysResolve().then((isIframeLogin) => {
                //     if (isIframeLogin) {
                childPostControl.sendMsg(postMsgPayloadFactory(SessionTriggerClickTypes.shareCard));
                // }
                // });
            },
        },
        {
            icon: <Iconfont className="icon" type="Share" />,
            label: lang('分享到班级'),
            onClick: () => {
                tryIframeRegisterPostLoginAlwaysResolve().then((isIframeLogin) => {
                    if (isIframeLogin) {
                        childPostControl.sendMsg(postMsgPayloadFactory(SessionTriggerClickTypes.shareToClass));
                    }
                });
            },
        },
        {
            icon: <Iconfont className="icon" type="Copy" />,
            label: <ClipBoardButton
                clipValue={props.sharePcUrl || location.href}
                buttonLabel={lang('复制链接')}
                successToast={lang('复制成功')}
                failToast={lang('复制失败,请手动复制')}
            />
        }
    ];
    return (
        <div className='biz-sib-share-ops-list'>
            {
                operationsList.map((opItem) => {
                    return (
                        <OperationOptionsItem
                            key={opItem.label}
                            label={opItem.label}
                            icon={opItem.icon}
                            onClick={opItem.onClick} />
                    );
                })
            }
        </div>
    )
};
interface IShareProps extends IOperationOptionsProps {
    className?: string;
}
export default function Share(props: IShareProps) {
    // const [overLayVisible, setOverLayVisible] = useState<boolean>(false);
    return (
        <div className={classNames('biz-sib-share-wrapper', props.className)}>
            <Popover
                // @ts-ignore
                overlayClassName={`biz-sib-share-body`}
                placement="top"
                hideArrow
                trigger="click"
                getPopupContainer={(triggerNode: HTMLElement) => (triggerNode && triggerNode.parentNode as HTMLElement)}
                content={
                    <OperationOptions sessionId={props.sessionId} sharePcUrl={props.sharePcUrl} />
                }>
                <div className="icon-wrapper">
                    <Tooltip
                        placement="top"
                        getPopupContainer={triggerNode => {
                            return (triggerNode?.parentNode as any)
                        }}
                        overlay={<span>{lang('分享')}</span>}>
                        <Iconfont className="share-icon" type="Share"/>
                    </Tooltip>
                </div>
            </Popover>
        </div>
    );
}
